module.exports = __webpack_public_path__ + "static/img/304.cb581d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200608/304.jpg
// module id = iknt
// module chunks = 0